export default {
  list: []
}



// WEBPACK FOOTER //
// ./src/features/tenant_representatives/store/state.js